import { render, staticRenderFns } from "./xcSetup.vue?vue&type=template&id=9f31ee7a&scoped=true&"
import script from "./xcSetup.vue?vue&type=script&lang=js&"
export * from "./xcSetup.vue?vue&type=script&lang=js&"
import style0 from "./xcSetup.vue?vue&type=style&index=0&id=9f31ee7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f31ee7a",
  null
  
)

export default component.exports